export function partnersClick(){
    let containers = document.querySelectorAll('.partners__container');

    if(!containers){
        return;
    }

    containers.forEach((container) => {
        let items = container.querySelectorAll('.partners__item');

        items.forEach((item) => {
            item.addEventListener('click', () => {
                items.forEach((rm) => {
                    rm.classList.remove('show');
                })
                item.classList.add('show');
            })
        })
    })
}